import { render } from "./BranchesDropdown.vue?vue&type=template&id=fa09491e"
import script from "./BranchesDropdown.vue?vue&type=script&lang=js"
export * from "./BranchesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__